module.exports = __webpack_public_path__ + "img/amazon-web-service.2ae709d3.png";